<template>
  <div class="pdf-container">
    <div class="column-content">
      <div>
        <header class="pdf-header">
          <h1 class="pdf-title">{{ title }}</h1>
          <p class="pdf-subtitle">Documento oficial generado automáticamente</p>
        </header>

        <section class="pdf-content">
          <p class="pdf-description">{{ description }}</p>

          <table class="pdf-table">
            <thead>
              <tr>
                <th>Dato</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in additionalData" :key="key">
                <td>{{ key }}</td>
                <td>{{ value }}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <p class="pdf-note">Este documento es una representación impresa de un formulario electrónico digital.</p>
          <div>
            <h2>Enlaces relacionados:</h2>
            <div v-for="(file, index) in links" :key="index">
              <a :href="file" target="_blank" rel="noopener noreferrer">{{ file }}</a>
            </div>
            <p>final de links</p>
          </div>
        </section>
      </div>

      <footer class="pdf-footer">
        <p class="pdf-signature">Firma: ________________________</p>
        <p class="pdf-date">Fecha: {{ currentDate }}</p>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "ElegantTemplate",
  props: {
    title: String,
    description: String,
    additionalData: Object, // Datos adicionales en formato clave-valor
    links: Object
  },
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
    };
  },
};
</script>

<style scoped>
.column-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: space-between;
}

.pdf-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  height: 841px;
  /* Ajusta este valor si es necesario */
  margin: 0 auto;
  /* Centra el contenido */
  padding: 20px;
  background: #ffffff;
  border: 2px solid #007bff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: "Arial", sans-serif;
  text-align: center;
}

.pdf-header {
  border-bottom: 2px solid #007bff;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.pdf-title {
  font-size: 22px;
  font-weight: bold;
  color: #007bff;
}

.pdf-subtitle {
  font-size: 14px;
  color: #666;
}

.pdf-content {
  margin: 15px 0;
}

.pdf-description {
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
}

.pdf-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.pdf-table th,
.pdf-table td {
  border: 1px solid #007bff;
  padding: 8px;
  text-align: left;
}

.pdf-table th {
  background: #007bff;
  color: var(--bg-popup);
}

.pdf-footer {
  margin-top: 20px;
  font-size: 14px;
  color: #555;
}

.pdf-signature {
  margin-bottom: 10px;
  font-style: italic;
}
</style>